import IPServie from "./ConectionDataService";
import axios from "axios";
class TokenValidate {
  //http_ = IPServie.getURL();
  getHeaders(token) {
    return {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: token,
    };
  }
  validarToken(tok) {
    var url = IPServie.getURL() + "/acumulacion/mf/autentication/validarToken";
    //console.log(url);
    return axios.get(url, { headers: this.getHeaders(tok) });
  }
}

export default new TokenValidate();
